import { usePage } from "@inertiajs/react";
import { ResponseBase } from "@/API/ResponseBase";

export const useEnvironment = () => {
  const {
    props: { environment },
  } = usePage<ResponseBase>();

  return environment;
};
